import { useId } from 'react';

import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  active?: boolean;
};
export const HeartIcon = ({ size = 2, active = false }: Props) => {
  const activeFillId = useId();
  const inactiveFillId = useId();
  const filterId = useId();
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={active ? `url(#${filterId})` : undefined}>
        <path
          d="M39.25 6.29492V19.4238L19.9736 38.9316L0.75 19.4248V6.29492L10.0127 0.869141L19.6475 6.5127L20.0264 6.73535L20.4062 6.5127L30.0127 0.869141L39.25 6.29492Z"
          fill={active ? `url(#${activeFillId})` : `url(#${inactiveFillId})`}
          fillOpacity={active ? 1 : 0.54}
          stroke="#FF7E34"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <linearGradient
          id={inactiveFillId}
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.499104" stopColor="#0E0E0E" />
          <stop offset="1" stopColor="#FF2828" />
        </linearGradient>
        <filter
          id={filterId}
          x="-0.000112653"
          y="9.41753e-06"
          width="69.3078"
          height="69.3078"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.48019"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_10673_120908"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.58686" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10673_120908"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10673_120908"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.95127" />
          <feGaussianBlur stdDeviation="1.11015" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_10673_120908"
          />
        </filter>
        <radialGradient
          id={activeFillId}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.1488 41.694) scale(22.8755)"
        >
          <stop stopColor="#FEF314" />
          <stop offset="1" stopColor="#FF4E22" />
        </radialGradient>
      </defs>
    </svg>
  );
};
